export const FINANCE_ROUTES = {
  FINANCE_INVOICES: "/finance/invoices",
  /** Payables hub (Chi pre-settlement). Detail is `/finance/payables/:payableId`. */
  FINANCE_PAYABLES: "/finance/payables",
  /** Payment dossiers catalog (HSTT types + ĐNTT layout). List; detail is `/finance/billing/:dossierTypeId`. */
  FINANCE_BILLING: "/finance/billing",
  /** Alias → FINANCE_BILLING (kept for deep links). */
  FINANCE_PAYMENT_DOSSIERS: "/finance/payment-dossiers",
  FINANCE_BANK: "/finance/bank",
  FINANCE_BANK_TRANSACTIONS: "/finance/bank/transactions",
  FINANCE_RECONCILIATION: "/finance/reconciliation",
  FINANCE_REPORTING: "/finance/reporting",
  FINANCE_CONTENT_REVIEW: "/finance/content-review",
} as const;

export type FinanceRouteKey = keyof typeof FINANCE_ROUTES;
